import React from "react";

const Expertise = () => {
  return (
    <section className="expertise">
      <div className="row  pt-2">
        <div className="col-6 text-right">
          <div
            className="bar brief animated-delay-0 text-right"
            style={{ float: "right" }}
          />
          <div className="expertise-category">
            <span>Languages</span>
          </div>
          <div style={{ clear: "both" }} />
        </div>
        <div className="col-6">
          <div className="description">
            <span>JavaScript (ES6+)</span>
            <span> Python (Core)</span>
            <span> PHP (Basic)</span>
          </div>
        </div>
      </div>
      <div className="row pt-2">
        <div className="col-6 text-right">
          <div
            className="bar insights animated-delay-1-5 text-right"
            style={{ float: "right" }}
          />
          <div className="expertise-category">
            <span>Front End</span>
          </div>
          <div style={{ clear: "both" }} />
        </div>
        <div className="col-6">
          <div className="description">
            <span> React </span>
            <span> Redux </span>
            <span> Bootstrap </span>
            <span> Material UI </span>
            <span> Font Awesome </span>
          </div>
        </div>
      </div>
      <div className="row pt-2">
        <div className="col-6 text-right">
          <div
            className="bar strategy animated-delay-3 text-right"
            style={{ float: "right" }}
          />
          <div className="expertise-category">
            <span>Back End</span>
          </div>
          <div style={{ clear: "both" }} />
        </div>
        <div className="col-6">
          <div className="description">
            <span>PHP</span>
            <span>MySQL (Basic)</span>
            <span>Firebase</span>
          </div>
        </div>
      </div>
      <div className="row pt-2">
        <div className="col-6 text-right">
          <div
            className="bar brief animated-delay-4-5 text-right"
            style={{ float: "right" }}
          />
          <div className="expertise-category">
            <span>Libraries and Technologies</span>
          </div>
          <div style={{ clear: "both" }} />
        </div>
        <div className="col-6">
          <div className="description">
            <span>Lodash</span>
            <span>Git, Github</span>
            <span>Redux Form</span>
            <span>Postman</span>
            <span>Zen coding (emmet)</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Expertise;
